import { Container, IconButton, Theme, useMediaQuery } from "@mui/material";
import ADPAppHeader from "../common/ADPAppHeader";
import { makeStyles } from "@mui/styles";
import { toRem16 } from "../../scss/utils/styles";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as DownArrow } from "../../assets/icons-svg/down-arrow.svg";
import { useAppState } from "../../provider/AppProvider";

const useStyles = makeStyles((theme: Theme) => {
    return {
        adpContentContainer: {
            paddingTop: "1.5rem",
            width: toRem16(640),
            maxWidth: toRem16(640),
            margin: "0 auto",
            [theme.breakpoints.down("sm")]: {
                width: "100%",
                padding: "1rem",
            },
        },
    };
});

const ADPLayout = ({ children, title }: any) => {
    const { isApiLoading } = useAppState();

    const smDevice = useMediaQuery("(max-width:600px)");
    const classes = useStyles();

    const [isVisible, setIsVisible] = useState(true);
    const scrollButtonRef = useRef(null);

    useEffect(() => {
        const scrollHandler = () => {
            const scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight =
                document.documentElement.scrollHeight ||
                document.body.scrollHeight;
            const clientHeight =
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            const scrollPercentage =
                (scrollTop / (scrollHeight - clientHeight)) * 100;

            setIsVisible(scrollPercentage < 30); // Show button when scrolled 20% or more
        };

        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, []);

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: "smooth",
        });
    };

    return (
        <Container maxWidth={false}>
            {!isApiLoading && <ADPAppHeader />}
            <div className={classes.adpContentContainer}>{children}</div>
            {title && (
                <IconButton
                    ref={scrollButtonRef}
                    onClick={scrollToBottom}
                    style={{
                        display: isVisible && !isApiLoading ? "block" : "none",
                        position: "fixed",
                        bottom: "32px",
                        right: smDevice ? "45%" : "50%",
                        backgroundColor: "#F15F22",
                        width: "60px",
                        height: "60px",
                    }}
                    aria-label="scroll-down"
                    size="large"
                >
                    <DownArrow />
                </IconButton>
            )}
        </Container>
    );
};

export default ADPLayout;
